import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Activity } from "lucide-react";

const EVENT_BADGE = {
  created: "bg-amber-soft/40 text-ink",
  deposit_captured: "bg-ink text-cream",
  restaurant_accept: "bg-amber/20 text-ink",
  restaurant_reject: "bg-rose-100 text-rose-900",
  hr_decision: "bg-amber/15 text-ink",
  admin_override: "bg-cream border border-tablo-border text-light-ink",
};

export default function AdminAudit() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("");

  const load = async () => {
    const params = {};
    if (filter) params.event_type = filter;
    params.limit = 200;
    const { data } = await api.get("/admin/audit", { params });
    setList(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const fmt = (d) => d ? new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "";

  return (
    <div className="space-y-5 animate-fade-up">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">Audit log</p>
          <h1 className="font-serif text-4xl flex items-center gap-3"><Activity className="w-7 h-7" strokeWidth={1.4}/>Booking events</h1>
          <p className="text-light-ink text-sm mt-2">Every state transition is recorded here. Use for dispute resolution.</p>
        </div>
        <div className="w-64">
          <Input placeholder="Filter by event_type (e.g. deposit_captured)" value={filter} onChange={(e) => setFilter(e.target.value)} className="bg-white border-tablo-border" data-testid="audit-filter"/>
        </div>
      </header>

      <div className="tablo-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream">
            <tr className="text-xs uppercase tracking-wider text-light-ink">
              <th className="text-left p-3">When</th>
              <th className="text-left p-3">Booking ID</th>
              <th className="text-left p-3">Event</th>
              <th className="text-left p-3">Payload</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-light-ink">No events.</td></tr>}
            {list.map((e) => (
              <tr key={e.id} className="border-t border-tablo-border hover:bg-off-white" data-testid={`audit-row-${e.id}`}>
                <td className="p-3 text-xs text-light-ink whitespace-nowrap">{fmt(e.created_at)}</td>
                <td className="p-3 font-mono text-[11px]">{e.booking_id}</td>
                <td className="p-3"><span className={`tablo-pill ${EVENT_BADGE[e.event_type] || "bg-cream border border-tablo-border"}`}>{e.event_type}</span></td>
                <td className="p-3 text-xs font-mono text-light-ink">{JSON.stringify(e.payload || {})}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
